module.exports = __webpack_public_path__ + "static/andrew-01aa1a3583930449833a97214b90c7ab.jpg";